import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, useHistory, Switch } from 'react-router-dom';
import { ADS, HOME_PAGE, LANDING_PAGE, LOGIN, CTKMJ2K, CTKMDEALHOT15, CTKMT7, LANDINGVNPLUS, CTKMVOUCHER50T8, LANDING_PAGE_MYTV, CTKM_CASHBACK_50, QR_CODE_MYVNPT, BAN_MOI_MyVNPT, BAN_CU_QUAY_LAI } from 'global/routes';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { ProgressTurn } from 'components';
import { useStore } from 'store';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/antd.css';
import 'react-multi-carousel/lib/styles.css';
import 'swiper/css/swiper.css';
import MainPage from 'pages/MainPage/MainPage';
import TagManager from 'react-gtm-module';
import Login3G from 'pages/Login3G/Login3G';
import Ads from 'pages/Ads/Ads';
import LandingPage from 'pages/LandingPage/LandingPage';
import CTKMj2k from 'pages/CTKMJ2K/CTKMj2k';
import CTKMDealHot15 from 'pages/CTKMDEALHOT15/CTKMDealHot15';
import CTKMThang7 from 'pages/CTKMT7/CTKMT7';
import CTKM50t8 from 'pages/CTKM50T8/CTKM50t8';
import LocaleProvider from './utils/providers/LocaleProvider';
import LandingPageMyTV from 'pages/LandingPageMyTV/LandingPageMyTV';
import LandingVNPPlus from 'pages/LandingVNPPlus/LandingVNPPlus';
import {GTM_ID_ROAMING, LIST_EXCLUDED_PATHS, LIVE_BOT_URL, URL_VNPTPAY} from 'global/environment';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { LIST_VNPP_TITLE_LOGOUT } from 'pages/Header/Header';
import { doGetUserInfoVplus, doGetUserPromoMenu, doLogout, doLogoutVplus, doTokenDevVplus, doTokenHoiVienEscVplus, doTokenHoiVienVplus } from 'store/action/userAction';
import PubSub from 'pubsub-js';
import CTKMCashback50 from 'pages/CTKMCashback50/CTKMCashback50';
import RoamingPackageMyVNPT from 'pages/QrCodeMyVnptVer2/RoamingPackageMyVNPT';
import PaymentNoti from 'pages/QrCodeMyVnptVer2/PaymentNoti/PaymentNoti';
import BanMoiMyVNPT from 'pages/BanMoiMyVNPT/BanMoiMyVNPT';
import BanCuQuayLai from 'pages/BanCuQuayLai/BanCuQuayLai';
import Instruction from "./pages/QrCodeMyVnptVer2/Instruction/Instruction";
import PrivacyPolicy from "./pages/Feature/Components/PrivacyPolicy";

// const GTM_ID = 'GTM-NHZ977Z';

function ScrollToTop() {
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [history.location.pathname]);

  return (null);
}

const RedirectOnPath = () => {
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    if (location.pathname.includes('/tinh-nang/thanh-toan-dich-vu')) {
      window.open(`${URL_VNPTPAY}/bill`, '_blank');
      history.goBack();
    } else if (location.pathname.includes('/tinh-nang/nap-tien')) {
      window.open(`${URL_VNPTPAY}/topup`, '_blank');
      history.goBack();
    } else if (location.pathname.includes('/tinh-nang/mua-ma-the')) {
      window.open(URL_VNPTPAY, '_blank');
      history.goBack();
    }
  }, [location.pathname]);
  return null;
}

const RedirectToLogin = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    const token = PubSub.subscribe("FORCE_LOGIN", () => {
      dispatch(doLogout());
      dispatch(doLogoutVplus());
      dispatch(doTokenDevVplus(""));
      dispatch(doTokenHoiVienEscVplus(""));
      dispatch(doTokenHoiVienVplus(""));
      dispatch(doGetUserInfoVplus(undefined));
      dispatch(doGetUserPromoMenu(LIST_VNPP_TITLE_LOGOUT));
      history.push('/');
    });
    return () => {
      PubSub.unsubscribe(token);
    };
  }, []);
  return null;
}

const App = () => {
  const store = useStore();

  useEffect(() => {
    // GTM
    TagManager.initialize({ gtmId: GTM_ID_ROAMING });
    const currentPath = window.location.pathname;

    // ko add Ekyc.js với 1 số Url web.
    const scriptEkyc = document.createElement('script');
    if (!currentPath.includes("/thanhtoan/roaming/hdsd")) {
      scriptEkyc.async = true;
      scriptEkyc.id = "oval_model";
      scriptEkyc.src = "https://ekyc-web.vnpt.vn/lib/VNPTBrowserSDKAppV2.3.3.js";
      document.body.appendChild(scriptEkyc);
    }

    // livebot
    const excludedPaths = LIST_EXCLUDED_PATHS ? LIST_EXCLUDED_PATHS.split(',').map(path => path.trim()) : [];
    const shouldInject = !excludedPaths.some(path => currentPath.includes(path));
    if (shouldInject) {
      const script = document.createElement('script');
      script.async = true;
      script.src = LIVE_BOT_URL + "?" + (Date.now() / 60000 | 0);
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
        document.body.removeChild(scriptEkyc);
      };
    } else {
      return () => {
        document.body.removeChild(scriptEkyc);
      };
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Provider store={store}>
        <LocaleProvider>
          <ProgressTurn />
          <RedirectOnPath />
          <RedirectToLogin />
          <Switch>
            <Route
              path={ADS}
              component={Ads}
            />
            <Route
              path={LOGIN}
              component={Login3G}
            />
            <Route
              path={LANDING_PAGE_MYTV}
              exact
              component={LandingPageMyTV}
            />
            <Route
              path={LANDING_PAGE}
              exact
              component={LandingPage}
            />
            <Route
              path={CTKMJ2K}
              // exact
              component={CTKMj2k}
            />
            <Route
              path={CTKMVOUCHER50T8}
              // exact
              component={CTKM50t8}
            />
            <Route
              path={CTKMDEALHOT15}
              // exact
              component={CTKMDealHot15}
            />
            <Route
              path={CTKMT7}
              // exact
              component={CTKMThang7}
            />
            <Route
              path={LANDINGVNPLUS}
              // exact
              component={LandingVNPPlus}
            />
            <Route
              path={CTKM_CASHBACK_50}
              // exact
              component={CTKMCashback50}
            />
            <Route
              path={QR_CODE_MYVNPT}
              exact
              component={RoamingPackageMyVNPT}
            />
            <Route
              path={`${QR_CODE_MYVNPT}/hdsd`}
              exact
              component={Instruction}
            />
            <Route
              path={`${QR_CODE_MYVNPT}/:slug`}
              exact
              component={PaymentNoti}
            />
            <Route
              path={BAN_MOI_MyVNPT}
              // exact
              component={BanMoiMyVNPT}
            />
            <Route
              path={BAN_CU_QUAY_LAI}
              // exact
              component={BanCuQuayLai}
            />
            <Route
              path={'/chinh-sach-rieng-tu'}
              render={(props) => <PrivacyPolicy {...props} showDocuments={false}/>}
            />
            <Route
              path={HOME_PAGE}
              component={MainPage}
            />

          </Switch>
        </LocaleProvider>
      </Provider>
    </Router>
  );
};

export default App;
